const validNum = (x) => {
  return x.toString() !== 'Infinity' && !x.toString().includes('NaN') && !x.toString().includes('-') && x.toString !== '' ? true : false
}

export default validNum